import Spinner from 'react-bootstrap/Spinner';

export function LoadingSign(props) {
  if (props.isLoading)
    return (
      <div>
          <div className="loadingMessageContainer"></div>
          <div className="messageText">
            <h1><Spinner animation="border" variant="primary"/> Loading...</h1>
          </div>
    </div>
    );
}

// export function ModalLoadingSign(props) {
//   if (props.isModalLoading)
//     return (
//       <div>
//         <div className="modalLoadingMessageContainer"></div>
//         <div className="modalMessageText">
//           <h1><Spinner animation="border" variant="primary"/> Loading...</h1>
//         </div>
//       </div>
//     );
// }
